import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { SITE } from "@/lib/site";

export default function CTASection({
  title = "Ready to Start Your Project?",
  subtitle = "Talk to a real general contractor about your home, your property, or your maintenance needs.",
  primaryLabel = "Request a Consultation",
  primaryTo = "/contact",
  secondaryLabel = "View Maintenance Plans",
  secondaryTo = "/maintenance-plans",
}) {
  return (
    <section className="section-pad bg-br-black text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1503594384566-461fe158e797?w=1800&q=80)", backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="absolute inset-0 bg-gradient-to-r from-br-black via-br-black/95 to-transparent" />
      <div className="container-br relative">
        <div className="max-w-3xl">
          <div className="br-eyebrow text-br-bronze-2">Black Ridge Construction</div>
          <h2 className="br-headline text-4xl md:text-5xl mt-3">{title}</h2>
          <p className="mt-4 text-gray-300 max-w-2xl">{subtitle}</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to={primaryTo} className="br-btn-primary">{primaryLabel} <ArrowRight size={14} /></Link>
            <Link to={secondaryTo} className="br-btn-secondary">{secondaryLabel}</Link>
            <a href={`tel:${SITE.phoneE164}`} className="br-btn-secondary"><Phone size={14}/> {SITE.phone}</a>
          </div>
        </div>
      </div>
    </section>
  );
}
